//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import layer from './layer.vue'
import { FactoryUtils } from "../../utils/FactoryUtils"
import BScroll from 'better-scroll'
    export default {
        name:'serveContentToast',
        data(){
            return {
              showFlag:false,
              title:'',
              list:[],
              planBScroll:null,
            }
        },
        components: {
          layer
        },
        created(){
            FactoryUtils.socialInfo().then(data =>{
                console.log('--',data)
                this.title=data.title
                this.list=data.list
            })
        },
        mounted(){
           
        },
        methods:{
          showToast(){
            this.showFlag = true;
            this.$nextTick(() => {
                if (!this.planBScroll) {
                    this.planBScroll = new BScroll(this.$refs.planBox, {
                        click: true,
                        scrollY: true,
                    });
                } else {
                    this.planBScroll.refresh()
                }
            })
          },
          close(){
            this.$refs.layerRef.removeTouch()
            this.showFlag = false;
            this.planBScroll = null;
          }
        }
    }
